import { render, staticRenderFns } from "./DesignSystem.vue?vue&type=template&id=2db6a3e0&"
import script from "./DesignSystem.vue?vue&type=script&lang=ts&"
export * from "./DesignSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db6a3e0')) {
      api.createRecord('2db6a3e0', component.options)
    } else {
      api.reload('2db6a3e0', component.options)
    }
    module.hot.accept("./DesignSystem.vue?vue&type=template&id=2db6a3e0&", function () {
      api.rerender('2db6a3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_showcase/DesignSystem.vue"
export default component.exports